const template = (data) => `
    <div class="grid__item">
        <article class="card card--article card--bg ${data.accent}">
            <a href="${data.url}" class="card__link">
                <div class="card__shape"></div>
                <div class="card__container">
                    <div class="card__image-container">
                        ${
                            data.image?.src
                                ? `<img class="card__image" src="${data.image?.src}" alt="${data.image?.alt}"  />`
                                : ''
                        }
                        ${
                            data.name
                                ? `<h3 class="card__heading">${data.name}</h3>`
                                : ''
                        }
                    </div>
                    <div class="card__content-container">
                        <div>
                            ${
                                data.tag
                                    ? `<span class="tag">${data.tag}</span>`
                                    : ''
                            }
                            ${
                                data.title
                                    ? `<h3 class="card__heading">${data.title}</h3>`
                                    : ''
                            }
                            <time class="card__description" datetime="${
                                data.dateTime
                            }">${data.date}</time>
                        </div>
                        <div class="card__cta card__cta--media">
                            <span class="card__cta-icon">
                                <svg width="8" height="9">
                                    <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#icon_play"></use>
                                </svg>
                            </span>
                            <div>
                                <p class="card__cta-text">Listen to podcast</p>
                                <time datetime="PT38M12S" class="card__cta-time">${
                                    data.podcastDuration
                                }</time>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </article>
    </div>
`
export default template
